import React from "react";
import { useDispatch } from "react-redux";
import { Form, Button } from "react-bootstrap";
import { Formik } from "formik";
import FormContainer from "../../components/FormContainer";
import style from "./Login.module.scss";
import { SyncOutlined } from "@ant-design/icons";
import { FiLock } from "react-icons/fi";
import { changePassword } from "../../redux/user/actions/user.actions";
import { changePasswordSchema } from "../../components/validation/Schema";

const Settings = () => {
  const dispatch = useDispatch();

  let userDetails;
  if (localStorage.getItem("userDetails")) {
    userDetails = JSON.parse(localStorage.getItem("userDetails"));
  }

  return (
    <>
      <FormContainer>
        <div className={style.form}>
          <div className="mb-5 d-flex justify-content-center"></div>

          <Formik
            initialValues={{
              password: "",
            }}
            validationSchema={changePasswordSchema}
            onSubmit={(values, { setSubmitting }) => {
              const newDetails = {
                user_id: userDetails?.data?.id,
                password: values.password,
              };

              dispatch(changePassword(newDetails, setSubmitting));
            }}
          >
            {({
              handleChange,
              handleSubmit,
              values,
              isSubmitting,
              setFieldValue,
              handleBlur,
              errors,
              touched,
            }) => (
              <React.Fragment>
                <Form onSubmit={handleSubmit}>
                  <Form.Group
                    controlId="password"
                    className={`${style.group} mb-3`}
                  >
                    <Form.Control
                      type="password"
                      placeholder="New Password"
                      className={`${style.input} rounded p-2`}
                      name="password"
                      onChange={handleChange}
                      value={values.password || ""}
                    ></Form.Control>
                    <FiLock className={style.icon} />
                  </Form.Group>
                  {errors.password ? (
                    <p className="text-danger small my-1">{errors.password}</p>
                  ) : null}

                  <Form.Group
                    controlId="password"
                    className={`${style.group} mb-3`}
                  >
                    <Form.Control
                      type="password"
                      placeholder="Confirm Password"
                      className={`${style.input} rounded p-2`}
                      name="cPassword"
                      onChange={handleChange}
                      value={values.cPassword || ""}
                    ></Form.Control>
                    <FiLock className={style.icon} />
                  </Form.Group>
                  {errors.cPassword ? (
                    <p className="text-danger small my-1">{errors.cPassword}</p>
                  ) : null}

                  <Button
                    type="submit"
                    variant="danger"
                    className={`${style.button} btn`}
                    disabled={
                      isSubmitting ||
                      !values.cPassword ||
                      !values.password ||
                      values.password !== values.cPassword
                    }
                  >
                    {isSubmitting ? <SyncOutlined spin /> : "Submit"}
                  </Button>
                </Form>
              </React.Fragment>
            )}
          </Formik>
        </div>
      </FormContainer>
    </>
  );
};

export default Settings;
